module.exports = __webpack_public_path__ + "media/img/pasarbella-1c4c4be0f5da5cd17567ee189e28cd87.png";